import React from 'react';
import {
  Select,
  TreeSelect,
  TreeSelectProps,
  SelectProps,
  Flex,
  Row,
  Checkbox,
  Pagination,
  Col,
  Button,
} from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import {
  FilterCommonInnerProps,
  FilterCommonProps,
  FilterTypes,
} from '@/component/FilterCommon/Filter';
import { axiosHttp } from '@/utils/http';
import {
  StaffItem,
  serviceStaffs,
} from '@/component/Filter/services/common/filter';
import { isError } from '@/component/common/error';
import { useSearchConditionPc } from '../hooks/useSearchCondition';
import { SelectModalPc } from '../Common/SelectModalPc';
import { FilterPc } from '../FilterPc';
import {
  DhbFilterForm,
  DhbFooterProps,
} from '@/component/PageComponent/PageComponent';
import { useGetData } from '@/component/PageComponent/hooks/requst';
import { TableResize } from '@/component/PageComponent/Table/TableResize';
import { useSelectRow } from '@/component/PageComponent/Table/hooks/columns';
import { useSelectModalList } from '../hooks/useSelectModalList';
import { LabeledValue } from 'antd/es/select';
import { useRequest } from 'ahooks' 
type FilterParams = Partial<{
  // kw: string,
  // startTime: any
  // start_time: any
  // endTime: any,
  page: number;
  pageSize: number;
  staff_type: 'salesman';
  isCustomize: true;
}>;

const initParams: FilterParams = {
  page: 1,
  pageSize: 10,
  staff_type: 'salesman',
  isCustomize: true,
  // kw: undefined,
  // start_time: moment().add(-30, 'd').startOf('d').format('YYYY-MM-DD HH:mm'),
  // endTime: '2024/01/09 23:59',
};
const columns = [
  {
    width: 50,
    dataIndex: 'sequence',
    render: (text:string, record:any, index:number) => {
      return index + 1;
    },
  },
  {
    width: '15%',
    title: '姓名',
    dataIndex: 'staff_name',
  },
  {
    width: '15%',
    title: '手机号',
    dataIndex: 'mobile',
  },
  {
    width: '25%',
    title: '所在部门',
    dataIndex: 'branch_name',
  },
  {
    title: '编号',
    dataIndex: 'staff_num',
  },
];
const DhbFooter = (
  props: DhbFooterProps & { onCancel(): void; onOk(): void },
) => {
  const {
    selectedRowKeys = [],
    onChange,
    dataSource = [],
    isAllSelect,
    total = 0,
    pageInfo,
    toggleSelectRowKeys,
  } = props;
  const { page = 1, pageSize = 10 } = pageInfo;

  return (
    <div style={{ padding: '10px' }}>
      <Row>
        <Col span={14}>
          {/* <Checkbox
          style={{ marginLeft: '23px' }}
          checked={isAllSelect}
          // indeterminate={isAllSelect}
          onChange={toggleSelectRowKeys}
        /> */}
          <Pagination
            style={{ textAlign: 'left' }}
            defaultPageSize={pageSize}
            total={total}
            current={page}
            onChange={(page, pageSize) => onChange({ page: page, pageSize })}
            onShowSizeChange={(current, pageSize) =>
              onChange({ page: 1, pageSize })
            }
            showQuickJumper={false}
          />
        </Col>
        <Col span={10}>
          <div style={{ textAlign: 'right' }}>
            <Button
              onClick={() => props.onCancel()}
              style={{ margin: '0 10px' }}
            >
              取消
            </Button>
            <Button type="primary" onClick={() => props.onOk()}>
              确定
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const listKey = 'staff_id';
interface StaffListModalProps {
  onChangeValues(values:string[],options: LabeledValue[],dataSource:StaffItem[]):void;
  onClose(): void;  
  value: any;
}
const StaffListModal = (props: StaffListModalProps) => {
  const [staffs, setStaffs] = React.useState<StaffItem[]>([]);
  const [count, setCount] = React.useState(0);
  const getStaffs = async (params: FilterParams) => {
    let res = await serviceStaffs(params);
    if (isError(res)) {
      return;
    }
    let data = res.data.list;
    setStaffs(data);
    setCount(res.data.count);
  };
  let { setParams, setPageInfo, loading, pageInfo, params } = useGetData({
    getData: getStaffs,
    defaultParams: initParams,
  });
  const {  selectedRowKeys,  isAllSelect,  toggleSelectRowKeys,setSelectedRowKeys,} = useSelectRow(staffs, listKey);
  React.useEffect(() => {
    getStaffs({ ...params, ...pageInfo });
  }, []);
  return (
    <Flex vertical style={{ height: '100%',padding:0}}>
      <h2 style={{ paddingLeft: '16px',margin:'16px 0 0 0' }}>客户业务员</h2>
      <DhbFilterForm
        defaultParams={initParams}
        loading={loading}
        onSearch={(params) => setParams(params)}
        filterProps={{
          filters: [
            {
              type: FilterTypes.Input,
              dataIndex: 'kw',
              flex: 1,
              placeholder: '名称/手机号/联系人/编号',
            },
            {
              type: FilterTypes.StaffBranch,
              dataIndex: 'branch_id',
              flex: 1,
              placeholder: '所在部门',
            },
            {
              type: FilterTypes.Select,
              dataIndex: 'status',
              flex: 1,
              options: [
                { label: '已启动', value: 'T' },
                { label: '已禁用', value: 'F' },
              ],
              placeholder: '状态',
            },
          ],
        }}
      />
      <TableResize
        style={{ flex: 1, padding: '0 20px 16px 16px' }}
        rowKey={listKey}
        pagination={false}
        columns={columns}
        dataSource={staffs}
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          onChange: (keys) => {
            setSelectedRowKeys(keys as any);
          },
        }}
        size="middle"
      />
      <DhbFooter
        selectedRowKeys={selectedRowKeys}
        dataSource={staffs}
        isAllSelect={isAllSelect}
        toggleSelectRowKeys={toggleSelectRowKeys}
        onChange={(pageInfo) => {
          setPageInfo(pageInfo);
        }}
        total={count}
        pageInfo={pageInfo}
        onCancel={() => {
          props.onClose();
        }}
        onOk={() => {
          props.onClose();
          let selectedRow: StaffItem[] = [];
          staffs.forEach((item) => {
            // let a = item[listKey];
            if (selectedRowKeys.includes(item[listKey])) {
              selectedRow.push(item);
            }
          });
          let options= selectedRow.map(item => ({label:item.staff_name,value:item.staff_id}))
          props.onChangeValues &&
            props.onChangeValues(selectedRowKeys, options, selectedRow);
        }}
      />
    </Flex>
  );
};

export interface FilterStaffPcProps extends SelectProps{


}

export const FilterStaffPc = (props: FilterStaffPcProps) => {
  // const [staffs, setStaffs] = React.useState<StaffItem[]>([]);
  const { list:staffs, setList:setStaffs,prependList } = useSelectModalList<StaffItem>({listKey:'staff_id',value:props.value,componentKey:'filterStaffPc'})
  const [isFirstFoucus,setIsFirstFoucus] = React.useState<boolean>(true);
  const {  ...reset } = props;
  const {run:getStaffs,loading} = useRequest(async (params?:{kw?:string}) => {
    const {kw} = params || {}
    let res = await serviceStaffs({
      page: 0,
      pageSize: 10,
      staff_type: 'salesman',
      isCustomize: true,
      kw:kw
    });
    if (isError(res)) {
      return;
    }
    let data = res.data.list;
    setStaffs(data);

  },{manual:true});
  // React.useEffect(() => {
  //   getStaffs();
  // }, []);
  let onChange: Required<SelectProps>['onChange'] = (value, option) => {
    props.onChange && props.onChange(value, option)
  };
  const focus = ()=>{
    if(isFirstFoucus){
      if(!staffs.length){
        getStaffs()
      }
      setIsFirstFoucus(false)
    }
  }
  return (
    <div>
      <SelectModalPc
        style={{ width: '100%'}}
        mode="multiple"
        onFocus={focus}
        loading={loading}
        // getInitData={focus}
        MoreComponent={({ onClose }) => (
          <StaffListModal
            value={props.value}
            onClose={onClose}
            onChangeValues={(values,option,sources)=>{
              prependList(sources)
              onChange(values,option)
            }}
          />
        )}
        placeholder={'客户业务员'}
        onSearch={(kw)=>{
          getStaffs({kw})
        }}
        {...reset}
        onChange={(value, option) => {
            

          onChange && onChange(value, option);
        }}
        options={staffs.map(staff=>{
          return {
            label: staff.staff_name,
            value: staff.staff_id
          }
        })}
      />
    </div>
  );
};
